import { TmBaseError } from '@/core/error/tmBaseError'

export class TmTiptapEditorError extends TmBaseError {
  public name = 'TmTiptapEditorError'
}
